import { put } from 'redux-saga/effects';

import { showError } from 'ducks/app/actions';
import * as errorTypes from './errorTypes';

export default {
  *[errorTypes.CANNOT_CREATE_SPECIAL_PROMO]({ message, errors }) {
    yield put(showError(errors || message));
  },
};
